import { useEffect, useState } from 'react';

/**
 * Debounces a rapidly changing value.
 *
 * Used for search inputs: without it every keystroke is a request, which floods the server and
 * makes results flicker as slower responses land after faster ones.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
